import axios from 'axios';
import Cookies from 'js-cookie';
import { cloneDeep as lodashClone } from 'lodash-es';

import useUserStore from '@lcsc-ui/store/user';
import { env } from '@lcsc-ui/utils/baseUrl';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

export default class Utils {
  // 简单地检测一下xss的属性
  static isXss(v) {
    if (!v) return false;
    return ['javascript', 'script', '<img', '<a', 'src=', '<iframe', 'href=', 'print', 'alert', 'onclick'].some((xss) =>
      v.includes(xss)
    );
  }
  static isLgScreen = () => {
    return window.innerWidth > 1552 || document.documentElement.clientWidth > 1552;
  };
  static isEmpty = (value) => {
    if (value === null) {
      return true;
    }

    if (Array.isArray(value)) {
      return value.length === 0;
    }

    if (typeof value === 'object' && value !== null) {
      return Object.keys(value).length === 0;
    }

    return false;
  };
  static getComputerKey = () => {
    const computerKey = Cookies.get('computerKey'); // 用户电脑的唯一标识
    if (!computerKey) {
      const key = this.getUuid();
      Cookies.set('computerKey', key, {
        domain: '.szlcsc.com',
        expires: 365,
        path: '/',
      });
      return key;
    }
    return computerKey;
  };
  // 埋点使用
  static getUuid() {
    return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  static base64Encode(input) {
    const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output = '';
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;

    input = Utils._utf8_encode(input);

    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
    }
    return output;
  }
  static _utf8_encode(string) {
    string = string.replace(/\r\n/g, '\n');
    let utftext = '';
    for (let n = 0; n < string.length; n++) {
      const c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  }
  // 检查创建嘉立创cas实例
  static checkJlcCas() {
    if (typeof window === 'undefined') {
      return;
    }
    if (window.jlcCasSdk) {
      const { JlcCas } = window.jlcCasSdk;
      if (!this.jlcCas) {
        let casUrl = 'https://test-passport.jlc.com';
        const env = process.env.NEXT_PUBLIC_APP_ENV;
        const apiMap = {
          uat: 'https://test-passport.jlc.com',
          pro: 'https://passport.jlc.com',
          dev: 'https://dev-passport.jlc.com',
          fat: 'https://fat-passport.jlc.com',
          local: 'https://dev-passport.jlc.com',
        };

        casUrl = apiMap[env];
        this.jlcCas = new JlcCas({
          ui: 'pc',
          appId: 'LC_PUB',
          casUrl,
          // 开启检查三方cookie(jlc.com的子域的系统不用开启，在需要进行间接或直接调用CAS接口前，调用CAS的工具接口检查是否支持三方cookie)
          needCheckThirdPartyCookie: true,
          // 需要回调时携带authCode(在跳转CAS链接时携带backCode参数，即可在回调时携带authCode)
          needCallbackAuthCode: true,
          trackBizParam: true,
          bizParamRules: {
            jlcGroupSource: true,
          },
          getBizExtendedParam() {
            return { jlcGroup_source: Cookies.get('jlcGroup_source') };
          },
        });
      }
    }
  }

  static tryLogin(triggerLoginOnFail) {
    if (typeof window !== 'undefined') {
      if (env === 'local') {
        return Promise.reject();
      }
      // 先检查实例
      this.checkJlcCas();
      if (window.jlcCasSdk) {
        return this.jlcCas.tryLogin({
          loginByCode: (code) => {
            console.log('执行了loginByCode', code);
            this.takeCodeToLogin(code);
          },
          onLogin: this.winLoginFn, // PC端弹窗登录（PC端一般都是弹窗登录）
          triggerLoginOnFail,
        });
      } else {
        return Promise.reject();
      }
    } else {
      return Promise.reject();
    }
  }

  static showWindowLogin(callback = new Function()) {
    if (typeof window !== 'undefined') {
      // console.log(window.jlcCasSdk, 'window.jlcCasSdk');
      if (window.jlcCasSdk) {
        this.tryLogin(true).catch(() => {
          this.winLoginFn(callback);
        });
      }
    }
  }

  static winLoginFn(callback = new Function()) {
    // 特殊情况 特殊处理
    if (['/newuser.html', '/point/use/info.html'].some((v) => window.location.href.includes(v))) {
      // 先检查实例
      this.checkJlcCas();
      this.jlcCas.toLogin();
      return;
    }
    return this.jlcCas.openLoginWindow({
      onLoginSuccess: () => {
        // 特殊情况 特殊处理
        if (['/newuser.html', '/point/use/info.html'].includes(window.location.href)) {
          window.reload();
          return;
        }
        // 弹窗登录成功代表支持三方cookie，可直接跨域获取authCode
        this.jlcCas.crossCheckLogin().then((code) => {
          this.takeCodeToLogin(code).then(() => callback && callback());
        });
      },
    });
  }
  static casLogin() {
    if (env === 'local') return;
    if (!window.jlcCasSdk) {
      // 失败五次就放弃加载sdk了
      let { hasLoadNum } = window;
      if (!hasLoadNum) hasLoadNum = 1;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.src = {
        uat: 'https://test-passport.jlc.com/sdk/1.7.1/index.min.js',
        pro: 'https://passport.jlc.com/sdk/1.7.1/index.min.js',
        dev: 'https://dev-passport.jlc.com/sdk/1.7.1/index.min.js',
        fat: 'https://fat-passport.jlc.com/sdk/1.7.1/index.min.js',
      }[env];
      script.onload = () => {
        this.casToLoginFn();
      };
      script.onerror = () => {
        script.remove();
        if (hasLoadNum > 5) {
          return;
        }
        hasLoadNum++;
        this.casLogin();
      };
      document.getElementsByTagName('head')[0].appendChild(script);
    } else {
      this.casToLoginFn();
    }
  }

  static casToLoginFn() {
    this.tryLogin(false)
      .then(() => {})
      .catch(() => {
        const code = this.getUrlParam('code');
        if (code) {
          this.takeCodeToLogin(code);
        }
      });
  }

  // 获取登录信息 触发base.js的autoRefreshLoginInfo方法，更改头部用户信息
  static reloadLoginFrame() {
    return new Promise((resolve, reject) => {
      // 改为接口的方式
      sendAxios({
        method: 'get',
        url: `/cas/user/info`,
        baseURL: Domains.lcscWwwUrl,
      })
        .then((res) => {
          if (res.code === 200) {
            window.customerCode = res.result.customerCode;
            resolve(res.result);
          } else {
            reject();
          }
        })
        .finally(() => {
          if (!window.customerCode) {
            reject();
          }
        });
    });
  }

  /**
   * 动态判断是否登录
   * @static
   * @return { Promise }
   * @memberof Utils
   * example:  const isLogin = await Utils.checkLogin();
   * if (isLogin) ... else ...
   *
   */
  static checkLogin() {
    return new Promise((resolve) => {
      sendAxios({
        method: 'get',
        url: '/cas/user/info',
        baseURL: Domains.lcscWwwUrl,
      })
        .then((res) => {
          if (res.code === 200) {
            // 存储客户是否星级客户
            window.checkStarValid = res.result.customerStarLevel;
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  // 获取cas地址
  static getCasTypeUrl(type = 'login', backUrl) {
    if (window.jlcCasSdk) {
      const { constants } = window.jlcCasSdk;
      const { ModuleEnum } = constants;
      this.checkJlcCas();
      return this.jlcCas.getModuleUrl(ModuleEnum[type.toUpperCase()], backUrl);
    }
  }

  // 获取登录地址
  static getCasLoginUrl(backUrl = '') {
    return this.getCasTypeUrl('LOGIN', backUrl);
  }

  // 获取注册地址
  static getCasRegisterUrl(backUrl = '') {
    return this.getCasTypeUrl('REGISTER', backUrl);
  }

  // 判断参数有无被encode编码
  static isEncode(params) {
    // 防止存在单纯%号，而不是%25的情况，需要使用try...catch兜底一下
    try {
      // 如果decode参数之后，原参数和decode之后的参数相等，那就是被编码了
      const decodeParams = decodeURIComponent(params);
      if (decodeParams === params) {
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }
  // 获取当前元素的距页面顶部高度，如果有多层，会循环相加
  static getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }

  static cloneDeep(v) {
    return lodashClone(v);
  }

  static setInfoSecurityLocalStorage(result) {
    this.setLocal('privateKey', result.privateKey);
    this.setLocal('publicKey', result.publicKey);
    this.setLocal('encryptSwitch', result.encryptSwitch || 'off');
    if (result.cipherClientVO) {
      const keyPair = result.cipherClientVO || {};
      if (keyPair.decryptPrivateHexKey && keyPair.encryptPublicHexKey) {
        this.setLocal('keyPair', keyPair);
      }
    }
  }
  static setToolbarProps(result) {
    window.toolBarSalesmanCodeAndEnv = { code: result.salesmanCode, env };
  }

  // 异步获取html代码片段
  static async getHtml(_html) {
    // 使用axios获取页面内容
    try {
      const response = await axios.get(_html);
      // 获取到的HTML页面代码
      const html = response.data;
      // 将HTML页面代码传递给视图渲染
      return html || '';
    } catch (error) {
      console.error('详情页获取html文本报错---', error);
      return '';
    }
  }

  static getUrlParam(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }

  static getCustomerCookieArray() {
    const customerCookie = Cookies.get('customer_info');
    let symbol = '-';
    if (customerCookie && customerCookie.includes(',')) {
      symbol = ',';
    }
    const customerCookieArray = customerCookie ? customerCookie.split(symbol) : [];
    return customerCookieArray;
  }

  static isLogined() {
    const customerCookieArray = Utils.getCustomerCookieArray();
    return customerCookieArray.length == 4 && customerCookieArray[3] == '1';
  }

  static dateFormat(date, fmt) {
    if (!date) {
      return '';
    }
    if (typeof date === 'string') {
      date = new Date(date);
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    }
    return fmt;
  }

  static replaceSpecialChar(sourceChar) {
    if (!sourceChar) {
      return '';
    }
    let re = new RegExp("'", 'g');
    let keyword = String(sourceChar).trim();
    keyword = keyword.replace(re, ' ');
    re = new RegExp('"', 'g');
    keyword = keyword.replace(re, ' ');
    re = new RegExp('‘', 'g');
    keyword = keyword.replace(re, ' ');
    re = new RegExp('“', 'g');
    keyword = keyword.replace(re, ' ');
    re = new RegExp('：', 'g');
    keyword = keyword.replace(re, ' ');
    return keyword;
  }

  static takeCodeToLogin(code, cb) {
    return new Promise((resolve, reject) => {
      sendAxios({
        method: 'get',
        url: `/cas/login?code=${code}`,
        baseURL: Domains.lcscWwwUrl,
      })
        .then(() => {
          this.reloadLoginFrame()
            .then((result) => {
              if (result) {
                useUserStore.getState().updateUserInfo(result);
                this.setInfoSecurityLocalStorage(result);
                this.setToolbarProps(result);
                if (window.location.pathname !== '/') {
                  // 非首页才走的逻辑
                  window.popList && window.popList(true);
                }
              }
            })
            .finally(() => {
              cb && cb();
            });
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  static isRightTaxNumber(taxValue) {
    const taxNumber = taxValue.trim();
    const length = taxNumber.length;

    /**
     * 18位
     * 前2位为数字，第3-6位必须为数字，其他位可以为任意数字或大写字母
     * 首位数字，第2位字母，第3-8位必须为数字，其他位可以为任意数字或大写字母
     * 首位字母，第2位数字，第3-7位必须为数字，其他位可以为任意数字或大写字母
     * 前2位字母，第3-8位必须为数字，其他位可以为任意数字或大写字母
     */
    const TAX_NUM_SIXTEEN_SEVENTEEN_PATTERN =
      /^(\d{6}[0-9A-Z]+)|(\d{1}[A-Z]{1}\d{6}[0-9A-Z]+)|([A-Z]{1}\d{6}[0-9A-Z]+)|([A-Z]{2}\d{6}[0-9A-Z]+)$/;
    /**
     * 20
     * 首位为数字，前6位必须为数字。如果7-15位均为数字，其他位可以是任意数字或大写字母；如果7-15位含有字母,则要求税号中字母不能为ISZO中任意一个
     * 首位为字母，第2-16位必须为数字，其他位可以为任意数字或大写字母
     */
    const TAX_NUM_NINETEEN_TWENTY_PATTERN = /^(\d{15}[0-9A-Z]+)|([A-Z]{1}\d{15}[0-9A-Z]+)$/;

    // 1、15位：纯数字或者数字字母组合
    if (length == 15) {
      // 纯数字或者数字字母组合
      if (/\d{15}/.test(taxNumber)) {
        return true;
      }
      // 数字字母组合
      if (/.*[A-Z].*/.test(taxNumber) && /.*\d.*/.test(taxNumber)) {
        return true;
      }
    } else if (length == 18) {
      // 2、18位：
      return TAX_NUM_SIXTEEN_SEVENTEEN_PATTERN.test(taxNumber);
    } else if (length == 20) {
      // 3、20位
      // 3.1 首位为数字，前6位必须为数字。如果7-15位均为数字，其他位可以是任意数字或大写字母
      // 首位为字母，第2-16位必须为数字，其他位可以为任意数字或大写字母
      if (TAX_NUM_NINETEEN_TWENTY_PATTERN.test(taxNumber)) {
        return true;
      }

      // 3.2 上面2种都没匹配上，则开始校验第三种
      // 首位为数字，前6位必须为数字。如果7-15位含有字母,则要求税号中字母不能为ISZO中任意一个
      // 首先前面6位必须为数字
      const preNum = taxNumber.substring(0, 6);
      if (!/^\d*$/.test(preNum)) {
        return false;
      }
      // 截取7-15位
      const substring = taxNumber.substring(6, 15);
      // 截取7-最后一位
      const substr = taxNumber.substring(6, length);

      // 7到15位包含字母
      if (/.*[A-Z].*/.test(substring)) {
        // 7到最后一位不含IOSZ
        return !/.*[IOSZ].*/.test(substr);
      }
      return false;
    } else {
      return false;
    }
    return false;
  }

  static logout() {
    if (window.confirm('您确定要退出吗？')) {
      window.logouting = true;

      Cookies.set('isLoginCustomerFlag', '', {
        domain: '.szlcsc.com',
        path: '/',
      });

      // 先检查实例
      this.checkJlcCas();
      this.jlcCas.toLogout(Domains.lcscMemberUrl + '/home/logout.html');
      sessionStorage.removeItem('user-sessionStorage');
    }
  }
  // 价格四舍五入相应的小数点，eg: 1.23456 取 2 位小数的四舍五入，priceRound(1.23456, 2) = 1.23, 取 4 位小数的四舍五入priceRound(1.23456, 4) = 1.2346
  static priceRound(v, len) {
    return Math.round(v * `1e${len}`) / `1e${len}`;
  }

  static isMobile() {
    return navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|MiuiBrowser)/i
    );
  }
  static getMoileUrl(url) {
    const prefix = env === 'pro' ? '' : env;
    return `https://${env === 'local' ? '' : prefix}m.szlcsc.com/${url}`;
  }

  // key中含有'%'
  static percent2percent25(URI) {
    if (URI?.indexOf('%') > -1) {
      return URI.replace(/%/g, '%25');
    }
    return URI;
  }

  // 编码
  static safeEncodeURI(URI, deep = 2) {
    let result = this.percent2percent25(URI);
    while (deep > 0) {
      result = encodeURIComponent(result);
      deep--;
    }
    return result;
  }

  // 解编码
  static safeDecodeURI(URI, deep = 2) {
    let result = URI;
    try {
      while (deep > 0) {
        result = decodeURIComponent(result);
        deep--;
      }
      return result;
    } catch {
      return result;
    }
  }

  // 获取带spm参数的URL
  static getBtnSpmQueryUrl(baseUrl, btn) {
    if (!baseUrl) return null;
    if (!btn) return baseUrl;

    if (window.monitor && typeof window.monitor.getButtonUrl === 'function') {
      try {
        return window.monitor.getButtonUrl(baseUrl, btn);
      } catch (error) {
        console.error('getButtonUrl', error);
        return baseUrl;
      }
    }
    return baseUrl;
  }

  // 动态添加大屏的className
  static addBigScreenClassName(sClassName, bClassName, onlyCompatibleSmallScreen) {
    // onlyCompatibleSmallScreen 只兼容小屏
    let finalClassStr = sClassName;
    if (!onlyCompatibleSmallScreen) {
      finalClassStr += ` ${bClassName}`;
    }
    return finalClassStr;
  }

  static async asyncAll(fetchList) {
    // 异常状态码
    const ret1 = await Promise.allSettled(fetchList);
    return ret1.map((item) => {
      if (item?.status === 'fulfilled') {
        return item?.value;
      } else if (item.status === 'rejected') {
        return null;
      }
      return null;
    });
  }

  // 是否为立创订货
  static isLcBook(provider) {
    return ['ti', 'waldom', 'rochester', 'te'].includes(provider);
  }

  // 单位转换显示：将数值转为模糊的kk展示，例如1999 = 1k
  static unitConversion(num) {
    if (num != 0 && !num) {
      console.error(`错误的数值${num}`);
      return 0;
    }
    // 小于10000直接返回
    if (num < 10000) {
      return num;
    }
    return this.unitConversionRecursion(num);
  }

  // 递归计算：等于10000=10k 大于10000 = 10k+ 1,999,999 = 1kk+  1,000,000,000 = 1kkk  9,999,999 = 9kk+
  // 能整除1000的不带+号，不能的则带+号
  static unitConversionRecursion(num) {
    const val = Number(num.toString().split('K')[0]);
    const unit = num.toString().split(val)[1];
    if (val / 1000 >= 1000) {
      // 除1000还大于1000继续递归
      return this.unitConversionRecursion(
        `${Math.floor(val / 1000)}${unit ? 'K' + unit : val % 1000 === 0 ? 'K' : 'K+'}`
      );
    } else if (val % 1000 === 0) {
      return `${Math.floor(val / 1000)}${unit ? 'K' + unit : 'K'}`;
    }
    return `${Math.floor(val / 1000)}${unit ? 'K' + unit : 'K+'}`;
  }

  // 复制文本
  static copyText(text, callback) {
    const textarea = document.createElement('textarea');
    textarea.setAttribute('readonly', 'readonly');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    if (document.execCommand('copy')) {
      document.execCommand('copy');
      callback?.();
    }
    document.body.removeChild(textarea);
  }

  // 正则匹配高亮标签中间的数据，例如<span class="LUCENE_HIGHLIGHT_CLASS">CR122</span>，返回：CR122
  static replaceLightCode(v) {
    if (typeof v !== 'string') {
      return v;
    }
    return v.replace(/<[^>]+>/g, '');
  }

  // 本地化的节流
  static localThrottle(methodName, delay, cb) {
    const nowTime = new Date().getTime();
    const localStorageTime = this.getLocal(methodName);
    if (!localStorageTime || nowTime - localStorageTime > delay) {
      this.setLocal(methodName, nowTime);
      cb();
    }
  }

  // 设置localStorage
  static setLocal(name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    try {
      window.localStorage.setItem(name, content);
    } catch (error) {
      console.error('localStorage满了', error);
      // 清理百度统计的localStorage
      const keys = Object.keys(window.localStorage);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (key.startsWith('fclog_')) {
          window.localStorage.removeItem(key);
        }
      }
      window.localStorage.setItem(name, content);
    }
  }

  //获取localStorage
  static getLocal(name) {
    if (!name) return;
    let content = null;
    try {
      content = window.localStorage.getItem(name) && JSON.parse(window.localStorage.getItem(name));
    } catch (error) {
      content = window.localStorage.getItem(name);
    }
    return content;
  }

  static checkReturnCoupon(data) {
    return Array.isArray(data) ? !data.filter((v) => Object.keys(v).length).length : true;
  }

  static getButtonParams(el) {
    try {
      if (!el || !(el instanceof HTMLElement)) {
        throw new Error(`el 不是一个HTML元素 ${el}`);
      }

      const queryString = el.dataset.needQuery;

      // 判空处理
      if (!queryString) {
        throw new Error('data-need-query 属性值为空或未定义，请检查元素配置');
      }

      // 解析 query 参数
      const params = new URLSearchParams(queryString);
      const lcsc_vid = params.get('lcsc_vid'); // 获取 lcsc_vid
      const spm = params.get('spm'); // 获取 spm

      if (!lcsc_vid && !spm) {
        throw new Error('缺少必要的参数 lcsc_vid 和 spm，请检查 data-need-query 的值');
      }

      return { lcsc_vid, spm };
    } catch (e) {
      console.warn('获取点击参数异常:', e.message);
      return {};
    }
  }

  static async getHugoHtml(fileHtmlPath) {
    let hugoHtml = '';
    if (!fileHtmlPath) {
      return hugoHtml;
    }
    // 获取hugo的html代码片段
    const old_hugoHtml = await this.getHtml(`${fileHtmlPath}/public/post/first/index.html`);
    // 匹配css标签
    const cssReg = /<link rel="stylesheet"(([\s\S])*?)>/g;
    const _css = old_hugoHtml.match(cssReg) || [];
    // 匹配script标签
    const scriptReg = /<script src="\.\.\/(([\s\S])*?)<\/script>/g;
    const _script = old_hugoHtml.match(scriptReg) || [];
    // 匹配body标签
    const bodyReg = /<body style="background: #fafafa;" id="mainForm">(([\s\S])*?)<\/body>/;
    const _body = old_hugoHtml.match(bodyReg) ? old_hugoHtml.match(bodyReg)[1] : '';
    // 拼接css+script+body
    hugoHtml = _css.join(' ') + _script.join(' ') + _body;
    // 替换相对路径
    return hugoHtml.replace(/\.\.\/\.\.\//g, fileHtmlPath + '/public/');
  }

  // 复制文本到剪贴板
  static copyTextToClipboard(text) {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log('Link copied to clipboard:', text);
        })
        .catch((err) => {
          console.error('Could not copy text:', err);
        });
    } else {
      // 兼容旧版浏览器的降级处理
      const textArea = document.createElement('textarea');
      textArea.value = text;

      // 防止页面滚动
      textArea.style.position = 'fixed';
      textArea.style.top = '-9999px';
      document.body.appendChild(textArea);

      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    }
  }
  static findFirstMroCatalogId(data, targetName) {
    function traverse(node) {
      if (!node || typeof node !== 'object') return null;

      // 如果当前节点是目标名称，返回 mroCatalogId
      if (node.catalogName === targetName) {
        return node.mroCatalogId;
      }

      // 遍历子目录
      if (node.sonCatalogList && Array.isArray(node.sonCatalogList)) {
        for (const child of node.sonCatalogList) {
          const result = traverse(child);
          if (result !== null) {
            return result;
          }
        }
      }

      return null;
    }

    // 遍历 data 中的所有顶层分类
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const result = traverse(data[key]);
        if (result !== null) {
          return result;
        }
      }
    }

    return null; // 没有找到时返回 null
  }

  // 获取cas的embedUrl
  static getCasEmbedUrl(promoCode) {
    const env = process.env.NEXT_PUBLIC_APP_ENV;
    const appId = 'LC_PUB';
    const redirectUrl = encodeURIComponent(window.location.href);
    const apiMap = {
      uat: `https://test-passport.jlc.com/embed/register?appId=${appId}&redirectUrl=${redirectUrl}&promoCode=${promoCode}`,
      pro: `https://passport.jlc.com/embed/register?appId=${appId}&redirectUrl=${redirectUrl}&promoCode=${promoCode}`,
      dev: `https://dev-passport.jlc.com/embed/register?appId=${appId}&redirectUrl=${redirectUrl}&promoCode=${promoCode}`,
      fat: `https://fat-passport.jlc.com/embed/register?appId=${appId}&redirectUrl=${redirectUrl}&promoCode=${promoCode}`,
      local: `https://dev-passport.jlc.com/embed/register?appId=${appId}&redirectUrl=${redirectUrl}&promoCode=${promoCode}`,
    };
    return apiMap[env];
  }

  // url拼接参数跳转
  static groupJumpUrl(url, jlcGroup_source, operation_code_mark) {
    const groupList = [
      'https://www.jlc.com/',
      'https://www.jlc-smt.com/',
      'https://lceda.cn/',
      'https://www.jlc-fpc.com/',
      'https://www.jlc-gw.com/',
      'https://www.jlc-drm.com/',
      'https://www.zxhgroup.com/',
      'https://www.jlc-zh.com/',
      'https://cut.jlc-gw.com/',
      'https://www.jlcfa.com/',
      'https://www.jlc-3dp.cn/',
      'https://www.jlc-cnc.com/',
      'https://ke.jlcfa.com/',
      'https://oshwhub.com/',
      'https://x.jlc.com/',
    ];
    if (groupList.find((item) => item === url?.trim())) {
      let query = '';
      if (jlcGroup_source) {
        query = jlcGroup_source;
      } else if (operation_code_mark) {
        query = 'lc_' + operation_code_mark;
      } else {
        query = 'lc';
      }
      return `${url}?jlcGroup_source=${query}`;
    }
    return url;
  }

  static getCommonRegExp() {
    return {
      // 中文
      zhCN: /[\u4e00-\u9fa5]/,
      // 手机号
      phone: /^1[3-9]\d{9}$/,
      // 邮箱
      email: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
      // 身份证号（15位或18位）
      idCard: /(?:\d{15}|\d{17}[\dXx])/,
      // 检查银行卡号（13-19位数字）
      bankCard: /\b\d{13,19}\b/,
    };
  }

  // 获取安全搜索关键字
  static getSafeSearchKeyword(keyword) {
    if (!keyword) return '';
    const { zhCN, phone, email, idCard, bankCard } = this.getCommonRegExp();
    if (
      zhCN.test(keyword) ||
      phone.test(keyword) ||
      email.test(keyword) ||
      idCard.test(keyword) ||
      bankCard.test(keyword)
    ) {
      return '';
    }
    return keyword;
  }
}
